import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { FONT_STACK } from '../constants/fontface.constant';
import CloseIcon from '../images/ChipDelete.svg';

export const MuiChip = (baseTheme: Theme): Partial<Components> => ({
  MuiChip: {
    styleOverrides: {
      root: {
        height: 'auto',
        fontSize: '0.875rem',
        padding: '4px',
        backgroundColor: baseTheme.palette.background.default,
        fontFamily: FONT_STACK,
        color: baseTheme.palette.text.secondary,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: baseTheme.palette.border,
        borderRadius: '8px',
        '&.MuiChip-clickable.MuiChip-outlined:hover,&.MuiChip-clickable.MuiChip-outlined:focus,&.MuiChip-deletable.MuiChip-outlined:focus':
          {
            backgroundColor: baseTheme.palette.background.default,
          },
      },
      outlinedPrimary: {
        color: baseTheme.palette.brand.main,
        borderColor: baseTheme.palette.brand.main,
      },
      outlined: {
        border: `1px solid ${baseTheme.palette.border}`,
      },
      label: {
        padding: '0 4px',
      },
      icon: {
        marginRight: '0',
        paddingLeft: '2px',
        marginLeft: '0',
      },
      deleteIcon: {
        marginLeft: '0',
        paddingRight: '2px',
        marginRight: '0',
        fontSize: '1rem',
        background: `url("${CloseIcon}") no-repeat center`,
        fill: 'transparent',
      },
    },
  },
});
